/**
 * Event Registration - Klaviyo 이벤트 등록 시스템
 * 이벤트 페이지에서 "알림 받기" 기능
 *
 * Klaviyo Client-side Track API 사용
 * (Klaviyo 스니펫이 theme.liquid에 이미 설치되어 있어야 함)
 */

(function () {
  'use strict';

  // --- Selectors ---
  const SELECTORS = {
    registerBtn: '.events-page__register-btn',
    registerForm: '.events-page__register-form',
    emailInput: '.events-page__register-email',
    submitBtn: '.events-page__register-submit',
    successMsg: '.events-page__register-success',
    errorMsg: '.events-page__register-error'
  };

  // --- Klaviyo Track Event ---
  function trackKlaviyoEvent(eventName, properties, email) {
    // Method 1: Klaviyo JS SDK (if available)
    if (window.klaviyo) {
      window.klaviyo.push(['track', eventName, properties]);
      if (email) {
        window.klaviyo.push(['identify', { $email: email }]);
      }
      return Promise.resolve(true);
    }

    // Method 2: Klaviyo Client API (fetch)
    // Requires Klaviyo public API key (company ID)
    const companyId = window.__KLAVIYO_COMPANY_ID || null;
    if (!companyId) {
      console.warn('Klaviyo not initialized. Event not tracked.');
      return Promise.resolve(false);
    }

    const payload = {
      data: {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: eventName } } },
          profile: { data: { type: 'profile', attributes: { email: email } } },
          properties: properties,
          time: new Date().toISOString()
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/events/?company_id=' + companyId, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.ok; })
      .catch(function () { return false; });
  }

  // --- Initialize Registration Buttons ---
  function initRegistration() {
    var buttons = document.querySelectorAll(SELECTORS.registerBtn);
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var card = btn.closest('[data-event-id]') || btn.closest('.events-page__up-next');
        if (!card) return;

        var form = card.querySelector(SELECTORS.registerForm);
        if (form) {
          // Toggle form visibility
          var isVisible = form.style.display !== 'none';
          form.style.display = isVisible ? 'none' : 'block';
          btn.textContent = isVisible ? '\uC54C\uB9BC \uBC1B\uAE30' : '\uCDE8\uC18C';
        }
      });
    });

    // Submit handlers
    var submitBtns = document.querySelectorAll(SELECTORS.submitBtn);
    submitBtns.forEach(function (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var card = submitBtn.closest('[data-event-id]') || submitBtn.closest('.events-page__up-next');
        if (!card) return;

        var emailInput = card.querySelector(SELECTORS.emailInput);
        var successMsg = card.querySelector(SELECTORS.successMsg);
        var errorMsg = card.querySelector(SELECTORS.errorMsg);
        var email = emailInput ? emailInput.value.trim() : '';

        // Validate email
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          if (errorMsg) {
            errorMsg.textContent = '\uC720\uD6A8\uD55C \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.';
            errorMsg.style.display = 'block';
          }
          return;
        }

        if (errorMsg) errorMsg.style.display = 'none';

        // Gather event data
        var eventTitle = card.dataset.eventTitle || card.querySelector('.events-page__up-next-title, .events-page__event-title')?.textContent?.trim() || '';
        var eventDate = card.dataset.eventDate || '';
        var eventType = card.dataset.eventType || '';
        var eventLocation = card.dataset.eventLocation || 'Online Shop';

        // Disable button
        submitBtn.disabled = true;
        submitBtn.textContent = '\uB4F1\uB85D \uC911...';

        // Track event
        trackKlaviyoEvent('EventRegistered', {
          EventTitle: eventTitle,
          EventDate: eventDate,
          EventType: eventType,
          EventLocation: eventLocation,
          EventURL: window.location.href
        }, email).then(function (ok) {
          if (successMsg) {
            successMsg.style.display = 'block';
          }
          // Hide form
          var form = card.querySelector(SELECTORS.registerForm);
          if (form) form.style.display = 'none';

          // Update button
          var registerBtn = card.querySelector(SELECTORS.registerBtn);
          if (registerBtn) {
            registerBtn.textContent = '\uB4F1\uB85D \uC644\uB8CC';
            registerBtn.disabled = true;
            registerBtn.classList.add('registered');
          }

          // Save to localStorage
          try {
            var registered = JSON.parse(localStorage.getItem('anchor_registered_events') || '[]');
            registered.push({ event: eventTitle, email: email, date: new Date().toISOString() });
            localStorage.setItem('anchor_registered_events', JSON.stringify(registered));
          } catch (e) { /* ignore */ }
        }).catch(function () {
          if (errorMsg) {
            errorMsg.textContent = '\uB4F1\uB85D \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.';
            errorMsg.style.display = 'block';
          }
          submitBtn.disabled = false;
          submitBtn.textContent = '\uB4F1\uB85D';
        });
      });
    });
  }

  // --- Check already registered events ---
  function checkRegistered() {
    try {
      var registered = JSON.parse(localStorage.getItem('anchor_registered_events') || '[]');
      var titles = registered.map(function (r) { return r.event; });

      document.querySelectorAll('[data-event-title]').forEach(function (card) {
        var title = card.dataset.eventTitle;
        if (titles.indexOf(title) !== -1) {
          var btn = card.querySelector(SELECTORS.registerBtn);
          if (btn) {
            btn.textContent = '\uB4F1\uB85D \uC644\uB8CC';
            btn.disabled = true;
            btn.classList.add('registered');
          }
        }
      });
    } catch (e) { /* ignore */ }
  }

  // --- Init ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRegistration();
      checkRegistered();
    });
  } else {
    initRegistration();
    checkRegistered();
  }
})();
